export const classGene = {
    0: 'Warrior',
    1: 'Knight',
    2: 'Thief',
    3: 'Archer',
    4: 'Priest',
    5: 'Wizard',
    6: 'Monk',
    7: 'Pirate',
    8: 'Berserker',
    9: 'Seer',
    10: 'Legionnaire',
    11: 'Scholar',
    16: 'Paladin',
    17: 'DarkKnight',
    18: 'Summoner',
    19: 'Ninja',
    20: 'Shapeshifter',
    21: 'Bard',
    24: 'Dragoon',
    25: 'Sage',
    26: 'SpellBow',
    28: 'DreadKnight',
}

export const rarityGene = {
    0: 'Common',
    1: 'Uncommon',
    2: 'Rare',
    3: 'Legendary',
    4: 'Mythic',
}

export const professionGene = {
    0: 'Mining',
    2: 'Gardening',
    4: 'Fishing',
    6: 'Foraging',
}

export const statsGene = {
    0: 'Strength',
    2: 'Agility',
    4: 'Intelligence',
    6: 'Wisdom',
    8: 'Luck',
    10: 'Vitality',
    12: 'Endurance',
    14: 'Dexterity',
}

export const statTraits = {
    0: 'Class',
    1: 'SubClass',
    2: 'Profession',
    3: 'Passive1',
    4: 'Passive2',
    5: 'Active1',
    6: 'Active2',
    7: 'StatBoost1',
    8: 'StatBoost2',
    9: 'Crafting1',
    10: 'Element',
    11: 'Crafting2',
}

export const activePassiveAbilityGene = {
    0: 'Basic1',
    1: 'Basic2',
    2: 'Basic3',
    3: 'Basic4',
    4: 'Basic5',
    5: 'Basic6',
    6: 'Basic7',
    7: 'Basic8',
    16: 'Advanced1',
    17: 'Advanced2',
    18: 'Advanced3',
    19: 'Advanced4',
    24: 'Elite1',
    25: 'Elite2',
    28: 'Exalted1',
}

export const activeAbilityGene = {
    0: {
        trait: 'Basic1',
        name: 'Poisoned Blade',
        description:
            'Deal damage to target enemy equal to (1.0*Basic).  This attack has an 80% chance to Poison target enemy.',
    },
    1: {
        trait: 'Basic2',
        name: 'Blinding Winds',
        description:
            'Deal damage to target enemy equal to (1.0*Basic).  This attack has an 80% chance to Blind target enemy.',
    },
    2: { trait: 'Basic3', name: 'Heal', description: 'Heal target Hero for 20% of max HP.' },
    3: { trait: 'Basic4', name: 'Cleanse', description: 'Cleanse target Hero.' },
    4: { trait: 'Basic5', name: 'Iron Skin', description: 'Reduce Physical damage taken by 20% for 4 Rounds.' },
    5: { trait: 'Basic6', name: 'Speed', description: 'Gain First Strike in each of the next 2 Rounds.' },
    6: {
        trait: 'Basic7',
        name: 'Critical Aim',
        description:
            'Activate to gain an additional 70% chance to Crit for 2 Rounds.  Deal damage to target enemy equal to (1.0*Basic).',
    },
    7: {
        trait: 'Basic8',
        name: 'Deathmark',
        description:
            'Target enemy receives 20% increased damage from allies for 2 Rounds.  Deal damage to target enemy equal to (1.0*Basic).',
    },
    16: {
        trait: 'Advanced1',
        name: 'Exhaust',
        description: 'Deal damage to target enemy equal to (1.0*Basic).  Exhaust target enemy.',
    },
    17: {
        trait: 'Advanced2',
        name: 'Daze',
        description: 'Deal damage to target enemy equal to (1.0*Basic).  Daze target enemy.',
    },
    18: {
        trait: 'Advanced3',
        name: 'Explosion',
        description:
            'Deal damage to target enemy equal to (1.0*Basic).  This attack explodes for 100% of damage dealt in an AOE, dealing damage to all enemies.',
    },
    19: {
        trait: 'Advanced4',
        name: 'Hardened Shield',
        description: 'Reduce Physical damage taken by 30% for 4 Rounds.',
    },
    24: {
        trait: 'Elite1',
        name: 'Stun',
        description: 'Deal damage to target enemy equal to (1.0*Basic).  Stun target enemy for 1 Round.',
    },
    25: {
        trait: 'Elite2',
        name: 'Second Wind',
        description: 'Hero heals itself for 50% of missing HP.  All party members are healed for 75% of that value.',
    },
    28: {
        trait: 'Exalted1',
        name: 'Resurrection',
        description: 'Return target ally to life.  Target ally returns Exhausted and with 50% max HP.',
    },
}

export const passiveAbilityGene = {
    0: { trait: 'Basic1', name: 'Duelist', description: 'When fighting 1v1, gain 20% bonus damage.' },
    1: { trait: 'Basic2', name: 'Clutch', description: 'Increase damage dealt by 30% when below 30% health.' },
    2: { trait: 'Basic3', name: 'Foresight', description: 'Permanently gain 8% Evasion.' },
    3: { trait: 'Basic4', name: 'Headstrong', description: '40% chance to not be affected by Daze.' },
    4: { trait: 'Basic5', name: 'Clear Vision', description: '40% chance to not be affected by Blind.' },
    5: { trait: 'Basic6', name: 'Fearless', description: '40% chance to not be affected by Fear.' },
    6: { trait: 'Basic7', name: 'Chatterbox', description: '40% chance to not be affected by Silence.' },
    7: { trait: 'Basic8', name: 'Stalwart', description: '40% chance to not be affected by Poison.' },
    16: {
        trait: 'Advanced1',
        name: 'Leadership',
        description: 'Allies deal 5% bonus damage.  This bonus cannot exceed 15% team-wide.',
    },
    17: { trait: 'Advanced2', name: 'Efficient', description: 'Reduce Mana consumption by 10%.' },
    18: {
        trait: 'Advanced3',
        name: 'Intimidation',
        description: 'Enemies deal 5% less damage.  This reduction cannot exceed 15% team-wide.',
    },
    19: {
        trait: 'Advanced4',
        name: 'Toxic',
        description: 'Each instance this Hero does damage has a 2% chance to apply Poison.',
    },
    24: {
        trait: 'Elite1',
        name: 'Giant Slayer',
        description:
            'If target enemy possesses greater HP currently than this Hero, deal 30% bonus damage to Heroes and 10% bonus damage to Monsters.',
    },
    25: {
        trait: 'Elite2',
        name: 'Last Stand',
        description:
            "When this Hero's health drops below 20%, become Invulnerable for 1 Round.  Can only occur once per Battle per gene.",
    },
    28: {
        trait: 'Exalted1',
        name: 'Second Life',
        description:
            'Upon death, return this Hero to life Exhausted and with 50% max HP.  Can only occur once per Battle per gene.',
    },
}

export const craftingGene = {
    0: { trait: 'Basic0', name: 'Blacksmithing', description: 'Blacksmithing' },
    2: { trait: 'Basic1', name: 'Goldsmithing', description: 'Goldsmithing' },
    4: { trait: 'Basic2', name: 'Armorsmithing', description: 'Armorsmithing' },
    6: { trait: 'Basic3', name: 'Woodworking', description: 'Woodworking' },
    8: { trait: 'Basic4', name: 'Leatherworking', description: 'Leatherworking' },
    10: { trait: 'Basic5', name: 'Tailoring', description: 'Tailoring' },
    12: { trait: 'Basic6', name: 'Enchanting', description: 'Enchanting' },
    14: { trait: 'Basic7', name: 'Alchemy', description: 'Alchemy' },
}

export const elementGene = {
    0: 'Fire',
    2: 'Water',
    4: 'Earth',
    6: 'Wind',
    8: 'Lightning',
    10: 'Ice',
    12: 'Light',
    14: 'Dark',
}

export const visualTraits = {
    0: 'Gender',
    1: 'HeadAppendage',
    2: 'BackAppendage',
    3: 'Background',
    4: 'HairStyle',
    5: 'HairColor',
    6: 'VisualUnknown1',
    7: 'EyeColor',
    8: 'SkinColor',
    9: 'AppendageColor',
    10: 'BackAppendageColor',
    11: 'VisualUnknown2',
}

export const genderGene = {
    1: 'Male',
    3: 'Female',
}

export const headAppendageGene = {
    0: 'None',
    1: 'Kitsune Ears',
    2: 'Satyr Horns',
    3: 'Ram Horns',
    4: 'Imp Horns',
    5: 'Cat Ears',
    6: 'Minotaur Horns',
    7: 'Faun Horns',
    8: 'Draconic Horns',
    9: 'Fae Circlet',
    10: 'Ragfly Antennae',
    11: 'Royal Crown',
    16: 'Jagged Horns',
    17: 'Spindle Horns',
    18: 'Bear Ears',
    19: 'Antennae',
    20: 'Fallen Angel Coronet',
    21: 'Power Horn',
    24: 'Wood Elf Ears',
    25: 'Snow Elf Ears',
    26: 'Cranial Wings',
    28: 'Insight Jewel',
}

export const backAppendageGene = {
    0: 'None',
    1: 'Monkey Tail',
    2: 'Cat Tail',
    3: 'Imp Tail',
    4: 'Minotaur Tail',
    5: 'Daishō',
    6: 'Kitsune Tail',
    7: 'Zweihänder',
    8: 'Skeletal Wings',
    9: 'Skeletal Tail',
    10: 'Afflicted Spikes',
    11: "Traveler's Pack",
    16: 'Gryphon Wings',
    17: 'Draconic Wings',
    18: 'Butterfly Wings',
    19: 'Phoenix Wings',
    20: 'Fallen Angel',
    21: 'Crystal Wings',
    24: 'Aura of the Inner Grove',
    25: 'Ancient Orbs',
    26: 'Arachnid Legs',
    28: 'Cecaelia Tentacles',
}

export const backgroundGene = {
    0: 'Desert',
    2: 'Forest',
    4: 'Plains',
    6: 'Island',
    8: 'Swamp',
    10: 'Mountains',
    12: 'City',
    14: 'Arctic',
}

export const hairStyleGene = {
    male: {
        0: 'Battle Hawk',
        1: 'Wolf Mane',
        2: 'Enchanter',
        3: 'Wild Growth',
        4: 'Pixel',
        5: 'Sunrise',
        6: 'Bouffant',
        7: 'Agleam Spike',
        8: 'Wayfinder',
        9: 'Faded Topknot',
        10: 'Side Shave',
        11: 'Ronin',
        16: 'Gruff',
        17: 'Rogue Locs',
        18: 'Stone Cold',
        19: "Zinra's Tail",
        20: 'Hedgehog',
        21: 'Delinquent',
        24: 'Skegg',
        25: 'Shinobi',
        26: 'Sanjo',
        28: 'Perfect Form',
    },

    female: {
        0: 'Windswept',
        1: 'Fauna',
        2: 'Enchantress',
        3: 'Pineapple Top',
        4: 'Pixie',
        5: 'Darkweave Plait',
        6: 'Dejanira',
        7: 'Courtly Updo',
        8: 'Centaur Tail',
        9: 'Lamia',
        10: 'Casual Ponytail',
        11: 'Wild Ponytail',
        16: 'Vogue Locs',
        17: 'Twin Vine Loops',
        18: 'Sweeping Willow',
        19: 'Odango',
        20: 'Goddess Locks',
        21: 'Lioness',
        24: 'Ethereal Waterfall',
        25: 'Kunoichi',
        26: 'Bowlcut',
        28: 'Lunar Light Odango',
    },
}

export const hairColorGene = {
    0: '#ab9159',
    1: '#af3853',
    2: '#578761',
    3: '#068483',
    4: '#48321e',
    5: '#66489e',
    6: '#ca93a7',
    7: '#62a7e6',
    8: '#c34b1e',
    9: '#326988',
    10: '#513f4f',
    11: '#d48b41',
    16: '#d7bc65',
    17: '#9b68ab',
    18: '#8d6b3a',
    19: '#566377',
    20: '#275435',
    21: '#77b23c',
    24: '#880016',
    25: '#353132',
    26: '#dbfbf5',
    28: '#8f9bb3',
}

export const eyeColorGene = {
    0: '#203997',
    2: '#896693',
    4: '#bb3f55',
    6: '#0d7634',
    8: '#8d7136',
    10: '#613d8a',
    12: '#2494a2',
    14: '#a41e12',
}

export const skinColorGene = {
    0: '#c58135',
    2: '#f1ca9e',
    4: '#985e1c',
    6: '#57340c',
    8: '#e6a861',
    10: '#7b4a11',
    12: '#e5ac91',
    14: '#aa5c38',
}

export const appendageColorGene = {
    0: '#c5bfa7',
    1: '#a88b47',
    2: '#58381e',
    3: '#566f7d',
    4: '#2a386d',
    5: '#3f2e40',
    6: '#830e18',
    7: '#6f3a3c',
    8: '#cddef0',
    9: '#df7126',
    10: '#835138',
    11: '#86a637',
    16: '#6b173c',
    17: '#a0304d',
    18: '#78547c',
    19: '#352a51',
    20: '#147256',
    21: '#cf7794',
    24: '#c29d35',
    25: '#211f1f',
    26: '#77b5cf',
    28: '#d7d7d7',
}
